<template>
  <section class="flex items-center flex-wrap gap-2.5 p-3 text-[#707C8E] text-base font-medium">
    <!-- <span>🌳 Carbon emissions are equivalent to the carbon absorbed by</span>
    <span class="text-[#038153]">
      <span class="no-localize-translate">{{ numberOfTrees }}</span>
      tree seedlings
    </span>
    <span>grown for 10 years.</span> -->
    <p>
      🌳 Carbon emissions are equivalent to the carbon absorbed by
      <span class="text-[#038153]">
        <span class="no-localize-translate">{{ numberOfTrees }}</span>
        tree seedlings
      </span>
      grown for 10 years.
    </p>
    <a
      href="https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references#seedlings"
      target="_blank"
      class="capitalize underline decoration-dotted"
    > learn more </a>
  </section>
</template>

<script>
export default {
  name: 'CarbonEquivalenceCalculatorNew',

  props: {
    emissions: {
      type: Number,
      required: true,
    },
  },

  computed: {
    numberOfTrees() {
      return thousands(Math.ceil(this.totalEmissions * 16.5))
    },
    totalEmissions() {
      return this.emissions
    },
  },
}
</script>
